var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"color"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"keypress":function($event){return _vm.$emit('keypress', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }